<template>
  <div id="app" :class="$store.state.screen ? 'screen' : ''">
    <topBar></topBar>
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view :key="key"/>
    </keep-alive>
    <router-view v-else />
    <footerModule />
  </div>
</template>

<script>
import footerModule from "@/components/footer";
import topBar from "@/components/topBar"
export default {
  name: 'App',
  components:{
    topBar,footerModule
  },
  computed:{
    key(){
      return this.$route.fullPath;
    }
  }
}
</script>

<style lang="less" scoped>
.screen{
  display: flex;
  flex-direction:column;
}

@media screen and (max-width: 1023px) {
  .screen{
    display: unset;
    flex-direction: unset;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue